var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAlert = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CC4A01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3298 21.0839L16.837 9.57968C16.7489 9.42719 16.5864 9.33361 16.4087 9.33307H16.2086C16.0308 9.33361 15.8645 9.42719 15.7701 9.57968L8.79298 21.0839C8.70315 21.2417 8.69924 21.4327 8.78261 21.5905L8.87282 21.7438C8.956 21.9019 9.12077 21.9994 9.30107 21.9971H22.7843C22.9645 21.9994 23.1332 21.9019 23.2229 21.7438L23.3194 21.5905C23.4092 21.4327 23.4131 21.2417 23.3298 21.0839ZM16.7709 18.9977C16.7671 19.1818 16.6148 19.331 16.4307 19.331H15.7638C15.5797 19.331 15.4335 19.1818 15.4373 18.9977L15.4509 18.3312C15.4547 18.1471 15.607 17.9979 15.7911 17.9979H16.458C16.6421 17.9979 16.7883 18.1471 16.7846 18.3312L16.7709 18.9977ZM16.5053 16.6649C16.59 16.6655 16.6631 16.6024 16.675 16.5182L16.9856 14.372C16.9991 14.2769 16.9711 14.1815 16.9087 14.1101C16.8464 14.0386 16.7557 13.9981 16.6599 13.9988H15.753C15.6572 13.9981 15.5649 14.0386 15.4996 14.1101C15.4343 14.1815 15.4024 14.2769 15.4119 14.372L15.6347 16.5182C15.6432 16.6024 15.7136 16.6655 15.7984 16.6649H16.5053Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Alert.f3866a21.svg";
export { ForwardRef as ReactComponent };